import script from "./Page.vue?vue&type=script&setup=true&lang=js"
export * from "./Page.vue?vue&type=script&setup=true&lang=js"

import "./Page.vue?vue&type=style&index=0&id=433e284a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-433e284a"]])

export default __exports__